<template>
  <div class="dialog-wrapper" style="display: inline-block;">
    <span @click="show()">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="50%"
               @close="init()">
      <h3 class="text-center" style="margin-bottom:20px;">新增结算</h3>
      <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
        <!--<div v-if="showText" style="margin-bottom:10px;">您尚未设置提现方式. <a href="/buyer/withdraw" style="cursor: pointer;"> 现在添加.</a></div>-->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="" prop="related_task_id">
              <YueDanIpt disabled style="width:100%;" model="related_task_id" :object="form" placeholder="结算单号"/>
            </el-form-item>
          </el-col>
<!--          <el-col :span="12">-->
<!--            <el-form-item label="" prop="bill_no_list_str">-->
<!--              <YueDanIpt style="width:100%;" model="bill_no_list_str" :object="form" placeholder="费用单号"/>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="12">
            <el-form-item label="" prop="payment_method">
              <el-select style="width:100%;" v-model="form.payment_method" clearable filterable
                         class="block height-50" placeholder="收款方式">
                <el-option v-for="item in paymentMethodList" :key="item.value" :label="item.name"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="" prop="payment_account_number">
              <YueDanIpt style="width:100%;" model="payment_account_number" :object="form" placeholder="收款账号"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="" prop="transaction_number">
              <YueDanIpt style="width:100%;" model="transaction_number" :object="form" placeholder="交易单号"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="" prop="handler">
              <YueDanIpt style="width:100%;" model="handler" :object="form" placeholder="经手人"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="" prop="payee_user">
              <YueDanIpt style="width:100%;" model="payee_user" :object="form" placeholder="收款用户"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="" prop="payee_user">
              <el-date-picker class="block height-50" style="width:100%;" placeholder="结算时间" value-format="yyyy-MM-dd"
                              format="yyyy-MM-dd" v-model="form.settlement_time">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24" style="display: flex;justify-content: start">
            <div class="uploadLI" v-for="(item,index) in form.voucher_list" :key="index">
              <img :src="item.content" style="width:100%;height:100%;object-fit:contain">
              <div class="operations on">
                <div class="operation" style="margin-right: 10px;">
                  <div class="operation replace" @click.stop="replace(index)"></div>
                </div>
                <div class="operation del" @click.stop="del(index)">

                </div>
              </div>
            </div>
            <el-form-item label="" prop="voucher_list">
              <div class="uploadLI">
                <div class="selectUpload" @click="handleUpload">
                  <div class="upload-demo"></div>
                  <div class="upload-title">上传凭证</div>
                  <div class="voucherFooter">
                    支持 jpg、jpeg、png 格式，大小不能超过20M
                  </div>
                </div>
                <!--<div class="form_error" v-show="formError.form.voucher_list" style="position:relative;top:10px;">-->
                <!--凭证是必填项，至少上传一张-->
                <!--</div>-->
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="" prop="remark">
              <YueDanIpt style="width:100%;" model="remark" :object="form" placeholder="备注"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!showText">
        <el-button class="block" type="primary" @click="submit()" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <div class="bg-black" v-if="uploadDialogVisible">
      <div class="dialog mobile-dialog" style="margin-top: 15vh">
        <div class="text-center redirct">
          <div class="sourcePicture text" :class="source =='远程'?'source':''" @click="remote()">远程图片</div>
          <div class="text">或</div>
          <div @click="local()" class="sourcePicture text" :class="source =='本地'?'source':''">本地图片</div>
          <div class="remote" v-if="source=='远程'">
            <!--<ul class="error-messages" v-if="!isEmptyErrors">
              <li>{{error}}</li>
            </ul>-->
            <el-input ref="remotePicture" v-model="remotePicture" placeholder="请复制图片地址或手动输入"
                      style="margin-bottom:10px;"></el-input>
            <el-button size="small" type="info" @click="confirm(goods)">确定</el-button>
            <div class="del" @click="onUploadCancel()">取消</div>
          </div>
          <uploader
            v-if="source =='本地'"
            icon="ico ico-uploadpic mt15"
            :item="goods"
            name="picture"
            :action="API_HOST + '/api/order_v2.php?api=upload_picture'"
            v-on:onUploadSuccess="onUploadSuccess"
            v-on:onUploadCancel="onUploadCancel()"></uploader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../../../services/api.js'
  import YueDanIpt from '../../../components/YueDanIpt'
  import Uploader from '@/components/Uploader'
  import {API_HOST} from "../../../services/constant";
  import {formatterNow} from "../../../services/formatTime";

  let _ = require('lodash')


  export default {
    name: 'AddForm',
    props: ['paymentMethodList',],
    components: {
      YueDanIpt: YueDanIpt,
      Uploader: Uploader
    },
    data() {
      return {
        remotePicture: '',
        operationImgIndex: -1,
        formError: {},
        goods: {},
        source: '远程',
        API_HOST: API_HOST,
        uploadDialogVisible: false,
        dialogFormVisible: false,
        loading: false,
        errors: null,
        list: null,
        showText: false,
        isEmptyErrors: true,
        form: {},
        rules: {
          express_type: [
            {required: true, message: '物流类型必填', trigger: 'change'}
          ],
          express_company_id: [
            {required: true, message: '物流公司必填', trigger: 'change'}
          ],
          express_order_id: [
            {required: true, message: '物流单号必填', trigger: 'change'}
          ],
          group_tag: [
            {required: true, message: '分组必填', trigger: 'change'}
          ],
          monitor_type: [
            {required: true, message: '监控类型必填', trigger: 'change'}
          ],
          monitor_start_time: [
            {required: true, message: '监控开始时间必填', trigger: 'change'}
          ],
          monitor_keyword: [
            {required: true, message: '监控关键字必填', trigger: 'change'}
          ],
        }
      }
    },
    methods: {
      del(index) {
        this.form.voucher_list.splice(index, 1)
      },
      replace(index) {
        this.operationImgIndex = index;
        this.uploadDialogVisible = true
      },
      handleUpload() {
        this.uploadDialogVisible = true;
        this.$nextTick(() => {
          this.$refs.remotePicture.focus();
        })
      },
      remote() {
        this.source = '远程'
      },
      local() {
        this.source = '本地'
        //this.isEmptyErrors = true
        this.error = ''
      },
      confirm() {
        if (!this.remotePicture) {
          //this.isEmptyErrors = false
          this.error = '图片地址不能为空'
          return
        }
        this.form.voucher_list.push({type: 1, content: this.remotePicture})
        this.uploadDialogVisible = false
        this.isEmptyErrors = true
        this.error = ''
      },
      onUploadSuccess: function (res) {
        let result = res.response.result
        if (this.operationImgIndex == -1)
          this.form.voucher_list.push({type: 1, content: result})
        else {
          this.form.voucher_list[this.operationImgIndex] = {type: 1, content: result};
        }
        this.uploadDialogVisible = false
        this.source = '远程'
        this.formError.good_image_list = false;
      },
      onUploadCancel() {
        this.uploadDialogVisible = false
        this.source = '远程'
        //this.isEmptyErrors = true
        this.error = ''
      },
      init() {
        this.form = {
          payment_method: '',
          remark: '',
          payment_account_number: '',
          transaction_number: '',
          transaction_number: '',
          voucher_list: [],
          handler: localStorage.getItem('username'),
          payee_user: '',
          settlement_time: formatterNow(),

        }
        this.isEmptyErrors = true
      },
      show() {
        this.init()
        this.dialogFormVisible = true;

      },
      submit() {
        this.$refs['form'].validate(async (valid, errors) => {
          this.isEmptyErrors = _.isEmpty(errors)
          this.errors = errors
          let param = JSON.parse(JSON.stringify(this.form));
          param.bill_no_list = this.form.bill_no_list_str.split(",");
          if (valid) {
            this.loading = true
            let res;
            if (this.form.id) {
              res = await api.updateBill(this, param)
            } else {
              res = await api.addBillSettlement(this, param)
            }
            this.loading = false;
            if (res.body.status == 'ok') {
              this.$emit('success')
              this.dialogFormVisible = false
            }
          } else {
            return false
          }
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  .pointer.disabled {
    color: #ccc;
  }

  .hoverCustomInputDiv {
    width: 400px;
    position: relative;
  }

  .hoverCustomInputDiv .underline input {
    text-decoration: underline;
  }

  .hoverCustomInputDiv .el-input__suffix {
    cursor: pointer;
    display: none;
  }

  .hoverCustomInputDiv:hover .el-input__suffix {
    display: block;
  }

  .formError {
    color: #ff4650;
    font-size: 12px;
  }

  .formbody {
    width: 90%;
    margin: auto;
  }

  .mobileImg {
    height: 60px !important;
    width: 60px !important;
    margin-right: 5px;
  }

  .select-all {
    width: 50%;
    margin: auto;
    overflow: hidden;
    border-radius: 3px;

    .expressBtn {
      text-align: center;
      display: inline-block;
      border: 1px solid #ccc;
      box-sizing: border-box;
      width: 100%;
      padding: 15px 0;
      cursor: pointer;

      &.is_active {
        background-color: #333;
        border: 1px solid transparent;
        color: #fff;
      }

      &.all {
        border-right: none;
      }

      &.notAll {
        border-left: none;
      }
    }
  }

  .uploadLI {
    border: 1px dashed #d9d9d9;
    width: 200px;
    height: 200px;
    position: relative;
    margin-right: 10px;
    padding: 5px;
    border-radius: 2px;
    cursor: pointer;

    .selectUpload {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .upload-demo {
      display: inline-block;
      height: 28px;
      width: 30px;
      background: url('../../../ico/upload@2x.png');
      background-size: 38px 38px;
      background-position: -4px -6px;
      margin: auto;
      margin-top: 0;
      margin-bottom: 20px;
    }

    .upload-title {
      text-align: center;
      font-size: 16px;
      color: #666666;
    }

    .voucherFooter {
      margin-top: 20px;
      color: #666666;
      font-size: 8px;
      text-align: center;
    }

    .operations {
      display: none;
      position: absolute;
      left: 15px;
      bottom: 15px;
      z-index: 100;
      width: 106px;
      height: 30px;

      .operation {
        float: left;
        width: 30px;
        height: 30px;
        background: rgba(51, 51, 51, 1);
        border-radius: 15px;
        cursor: pointer;
      }

      .replace {
        background: url('../../../ico/replace@2x.png');
        background-size: cover;
      }

      .del {
        background: url('../../../ico/delete@2x.png');
        background-size: cover;
      }
    }
  }

  .uploadLI:hover {
    .on {
      display: block;
    }
  }

  .bg-black {
    position: fixed;
    display: block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    z-index: 2111;
    background: rgba(0, 0, 0, .3);
  }

  .dialog {
    width: 450px;
    position: relative;
    margin: 0 auto 50px;
    background: #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
    padding: 20px;
  }

  .redirct {
    font-size: 24px;
    line-height: 33px;

    .source {
      color: #337ab7;
    }

    .text {
      display: inline-block;
      margin-right: 10px;
    }

    .sourcePicture:hover {
      color: #337ab7;
      cursor: pointer;
    }

    .remote {

      .error-messages {
        display: block;
        background-color: #fff1f1;
        padding: 10px;
        text-align: center;
        color: #ff4650;
        line-height: 17px;
        margin-bottom: 10px;
        border-radius: 5px;

        li {
          font-size: 12px;
        }
      }

      .del {
        padding: 0px 15px;
        display: inline-block;
        border: 1px solid #cccccc;
        font-size: 12px;
        height: 32px;
        vertical-align: bottom;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }

  .gooditem {
    margin-bottom: 10px;
    cursor: pointer;
    border: 1px solid transparent;
    /*border-bottom: 1px solid #ccc;
    height:80px;*/
  }

  /*.gooditem:hover{
    border-bottom:1px solid #333;
  }*/
  .goods_image {
    position: relative;
    width: 90px;
    height: 90px;
    border-radius: 10px;
  }

  .goods_number {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #333;
    color: white;
    position: absolute;
    right: -4px;
    top: -8px;
    text-align: center;
    line-height: 20px;
  }

  .goods_number_right {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #333;
    color: white;
    text-align: center;
    line-height: 20px;
    display: inline-block;
    margin-right: 4px;
  }

  .goods_info {
    width: 100%;
    position: relative;
  }

  .goods_info.noeditMode:hover {
    z-index: 1000;
  }

  .goods_delete {
    position: absolute;
    bottom: -8px;
    left: 10px;
    height: 32px;
    width: 80px;
    text-align: center;
    border: 1px solid #DEE1EB;
    border-radius: 3px;
    background: #F3F3F9;
    font-size: 12px;
    color: #686B73;
    cursor: pointer;
  }

  .goods_info.noeditMode .goods_delete {
    display: none;
  }

  .goods_info.noeditMode:hover .goods_delete {
    display: block;
  }

  .goods_params {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .goods_params.noeditMode {
    display: block;
  }

  .goods_params.hasPicture {
    width: calc(100% - 95px);
  }

  .goods_params_row.noeditMode {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding-right: 10px;
    height: 100%;
  }

  .goods_info_row {
    display: flex;
    justify-content: space-between;
  }

  .goods_info_row.editMode {
    margin-bottom: 10px;
  }

  .goods_info_row el-input {
    width: 190px;
  }

  .priceInfo_div {
    padding: 10px 10px 0;
    border-top: 1px solid #ccc;
    padding-top: 10px;
  }

  .priceInfo_row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .priceInfo_row.editMode {
    align-items: center;

    .priceInfo_row_right {
      text-align: right;
    }
  }

  .form_error {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
  }

  .round_button {
    border: none;
    background: transparent;
    color: #333;
    cursor: pointer;
  }
</style>

<style lang="scss" scoped>
  .form-item {
    display: flex;
    justify-content: space-between;
  }

  .detail-table-head {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #D7D7D7;
    padding-bottom: 10px;
  }

  .detail-table-body {
    max-height: 300px;
    overflow: auto;
  }

  .detail-table-row {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #D7D7D7;
    padding: 10px 0;
    align-items: center;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/amount_bill/CreateSettle.vue